import { ActivitySchemaModel, ActivitySchemaType } from "./ActivitySchemaModel";

interface DynamicFormOptionsResponse {
	key: string;
	value: string;
}

interface DynamicPayloadNormalizedSubmission {
	[key: string]: any;
}

interface DynamicFormOptionsResponseListItem {
	[key: string]: string;
}

interface DynamicFormOptionsQueryParams {
	name: string;
	type: string;
	minLength: number;
}

interface DynamicFormOptions {
	sso: boolean;
	url: string;
	response: DynamicFormOptionsResponse;
	responseList: DynamicFormOptionsResponseListItem[];
	value: DynamicFormOptionsResponseListItem;
	queryParams?: DynamicFormOptionsQueryParams[];
	retrievingList?: boolean;
}

interface DynamicForm {
	[key:string]: {
		label: string;
		info: string;
		value: string|number|boolean;
		type: ActivitySchemaType;
		required: boolean;
		order: number;
		isText: boolean;
		isMemo: boolean;
		isDate: boolean;
		isCheckbox: boolean;
		isDropdown: boolean;
		isDropdownLazy: boolean;
		readonly?: boolean;
		options?: DynamicFormOptions; 
	}
}

export class ActivityDynamicFormModel {
	form: DynamicForm = {};
	private _schema: ActivitySchemaModel;

	constructor(schema: ActivitySchemaModel) {
		this._schema = schema;
		this._mountForm()
	}

	normalize():DynamicPayloadNormalizedSubmission {
		const formNormalized:DynamicPayloadNormalizedSubmission = {};

		for (const key in this.form) {
			if (this.form.hasOwnProperty(key)) {
				if (this.form[key].isDate && this.form[key].value) {
					formNormalized[key] = (this.form[key].value as unknown as Date).toISOString();
					continue;
				}

				if (this.form[key].isDropdown && this.form[key].options!.value) {
					formNormalized[key] = this.form[key].options!.value;
					continue;
				}

				formNormalized[key] = this.form[key].value; 
			}
		}

		return formNormalized;
	}

	private _mountForm():void {
		if (!this._schema?.fields) {
			return
		}

		const form:DynamicForm = {};

		Object.keys(this._schema.fields).forEach((key) => {
			// @ts-ignore
			form[key] = {};
			form[key].label = this._schema.fields[key].label;
			form[key].info = this._schema.fields[key].info || '';
			form[key].type = this._schema.fields[key].type;
			form[key].order = this._schema.fields[key].order;
			form[key].required = this._schema.fields[key].required;
			form[key].readonly = this._schema.fields[key].readonly;

			switch (form[key].type) {
				case ActivitySchemaType.Text:
					form[key].isText = true;
					form[key].value = '';
					break;
				case ActivitySchemaType.Memo:
					form[key].isMemo = true;
					form[key].value = '';
					break;
				case ActivitySchemaType.Date:
					form[key].isDate = true;
					break;
				case ActivitySchemaType.Checkbox:
					form[key].isCheckbox = true;
					form[key].value = false;
					break;
				case ActivitySchemaType.Dropdown:
					form[key].isDropdown = true;
					form[key].isDropdownLazy = this._schema.fields[key].options?.queryParams ? true : false;
					form[key].options = this._schema.fields[key].options as unknown as DynamicFormOptions;
					form[key].options!.responseList = [];
					form[key].options!.value = {};
					if (form[key].isDropdownLazy) {
						form[key].options!.retrievingList = false;
					}
					break;
			}
		})
		
		// Sort the object before setting to the real form object
		this.form = Object.fromEntries(Object.entries(form).sort(([,a],[,b]) => a.order-b.order));
	}
}
